import { Injectable } from '@angular/core';
import { Firestore, addDoc, collection, collectionData, doc, docData, deleteDoc, updateDoc, DocumentReference, setDoc, query, where, CollectionReference, DocumentData, getDocs} from '@angular/fire/firestore';
import { arrayUnion } from '@firebase/firestore';
import { Observable } from 'rxjs';
import { SharedService } from 'src/app/shared/shared.service';

@Injectable({
  providedIn: 'root'
})
export class SettingsService {
	settingsCollection: CollectionReference<DocumentData>;

  constructor(private firestore:Firestore, private sharedService: SharedService) {
	this.settingsCollection = collection(this.firestore, "settings");
  }

  async addEditSettingLevel(data: any) {
    return new Promise<any>((resolve, reject) => {
      try{
        let collectionRef = 'settings/levels';
        const ref = doc(this.firestore, collectionRef);
        setDoc(ref, data);
        resolve(true)
      }catch(e){
        reject(false);
      }
    })

  }

  addEditLevels(data: any, id:string) {
    let collectionRef = 'levels';
    if(!id) {
      id = doc(collection(this.firestore, collectionRef)).id;
    }
    data.id = id;
    collectionRef = `levels/${id}`;
    const ref = doc(this.firestore, collectionRef);
    return setDoc(ref, data);
  }

  getLevels(){
    const ref = collection(this.firestore, `levels`);
    return collectionData(ref, {idField: 'id'}) as Observable<any>;
  }

	async getOrganisationHierarchy(organisationId: string) {
		try {
			const orgDocRef = doc(this.firestore, `organisations/${organisationId}`);
			const orgDataObs = docData(orgDocRef, {
				idField: 'id'
			});
			const orgData: any = await this.sharedService.getObservableRes(orgDataObs);
      console.log(orgData);
			return orgData?.hierarchies ?? [];
		} catch (err) {
			console.log('Unable to get organisation hierarchy.', err);
		}
	}

	async getOrganisationDetails(orgId: string) {
		try {
			const orgDocRef = doc(this.firestore, `organisations/${orgId}`);
			const orgDataObs = docData(orgDocRef, {
				idField: 'id'
			});
			return await this.sharedService.getObservableRes(orgDataObs);
		} catch (err) {
			console.log('Unable to get organisation details.', err);
		}
	}

	getOrganisationDetailsObs(orgId: string) {
		try {
			const orgDocRef = doc(this.firestore, `organisations/${orgId}`);
			return docData(orgDocRef, {
				idField: 'id'
			});
		} catch (err) {
			console.log('Unable to get organisation details.', err);
		}
	}

	getOrganisationHierarchyObs(organisationId: string) {
		try {
			const orgDocRef = doc(this.firestore, `organisations/${organisationId}`);
			return docData(orgDocRef, {
				idField: 'id'
			});
		} catch (err) {
			console.log('Unable to get organisation hierarchy');
		}
	}

  // getSettingsLevelsName(){
  //   const ref = doc(this.firestore, `settings/levels`);
  //   return docData(ref) as Observable<any>;
  // }

  deleteSetting(id:string) {
    return new Promise((resolve, reject) => {
      try{
        const del = doc(this.firestore, `settings/${id}`);
        deleteDoc(del);
        resolve(true);
      }catch(err){
        resolve(false);
      }
    });
  }

  async saveNewLevel(hierarchies: any, id: string) {
    let collectionRef = `organisations/${id}`;
    console.log('id',id);
    console.log('data', hierarchies);
    try {
      const ref = doc(this.firestore, collectionRef);
      await updateDoc(ref, {
		hierarchies
	  });
    } catch (err) {
      console.log('Could not create new templates: ', err);
    }
    }

  // async saveNewLevel(levelName: string) {
	// try {
	// 	const settingsLevelDoc = doc(this.firestore, 'settings/levels');
	// 	await updateDoc(settingsLevelDoc, {
	// 		names: arrayUnion({
	// 			name: levelName,
	// 		})
	// 	});
	// } catch (err) {
	// 	console.log('Could not create new level: ', err);
	// }
  // }

  async deleteLevel(levelIndex: number, currentHierarchies: any, organizationId: string, organizationHierarchy: any) {
	try {
		currentHierarchies.splice(levelIndex, 1);
		organizationHierarchy.splice(levelIndex, 1);

		const docRef = doc(this.firestore, `organisations/${organizationId}`);
		await updateDoc(docRef, {
			hierarchies: currentHierarchies,
			hierarchy: organizationHierarchy
		});

		// get all users in this org, edit levels in their data, so this level does not exist anywhere anymore.
		const userQuery = query(collection(this.firestore, 'users'), where('organisationId', '==', organizationId));
		const userQueryObs = collectionData(userQuery, {
			idField: 'id'
		});
		const usersData: any = await this.sharedService.getObservableRes(userQueryObs);
		for (let user of usersData) {
			let didChange: boolean = false;
			if (user.level.length <= levelIndex + 1) {
				didChange = true;
				user.level.splice(levelIndex, 1);
			}

			if (didChange) {
				const userDocRef = doc(this.firestore, `users/${user.id}`);
				await updateDoc(userDocRef, {
					level: user.level
				});
			}
		}
	} catch (err) {
		console.log('Could not delete level: ', err);
	}
  }
}
